module.exports = __webpack_public_path__ + "static/banner-2-37b6627d99126c9e5093f13b0ac2d5e1.png";